import { Component, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RecoverRequest } from '../../../../models/auth/recover-request';
import { IdentityService } from '../../../../services/identity/identity.service';

@Component({
  selector: 'app-recover-form',
  imports: [FormsModule],
  templateUrl: './recover-form.html',
  styleUrl: './recover-form.scss',
})
export class RecoverForm {
  recoveryUsername = signal('');
  requestedMethod = signal(0);

  changeView = output<'login' | 'enter-code'>();
  recoveryRequested = output<string>();

  constructor(
    private auth: IdentityService
  ) { }

  sendRecoveryLink() {
    console.log(`Sending recovery link to: ${this.recoveryUsername()} via method: ${this.requestedMethod()}`);

    // Create the recovery request.
    let request = new RecoverRequest();
    request.userName = this.recoveryUsername();
    request.requestedMethod = this.requestedMethod();

    this.auth.requestAccountRecovery(request).subscribe({
      next: (response) => {
        // Here, you would call a service to handle the recovery logic.
        this.recoveryRequested.emit(this.recoveryUsername());
        this.changeView.emit('enter-code');
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
}
